import { motion } from "framer-motion";

const looks = [
  { bg: "#005F60", fg: "#FAF8F5", block: "#FF682F", clip: "polygon(0 62%, 100% 38%, 100% 100%, 0 100%)" },
  { bg: "#FF682F", fg: "#121518", block: "#005F60", clip: "polygon(55% 0, 100% 0, 100% 100%, 20% 100%)" },
  { bg: "#F3EFEA", fg: "#121518", block: "#FFCC00", clip: "polygon(0 55%, 60% 55%, 60% 100%, 0 100%)" },
  { bg: "#121518", fg: "#FAF8F5", block: "#FFCC00", clip: "polygon(0 100%, 100% 45%, 100% 100%)" },
  { bg: "#FFCC00", fg: "#121518", block: "#005F60", clip: "polygon(0 70%, 100% 70%, 100% 100%, 0 100%)" },
  { bg: "#003E40", fg: "#FAF8F5", block: "#FFCC00", clip: "polygon(65% 45%, 100% 45%, 100% 100%, 65% 100%)" },
  { bg: "#EAE4D9", fg: "#121518", block: "#FF682F", clip: "polygon(0 48%, 100% 72%, 100% 100%, 0 100%)" },
];

const Face = ({ title, look }) => (
  <div
    className="relative aspect-[2/3] w-full overflow-hidden shadow-[0_24px_50px_-24px_rgba(18,21,24,0.55)]"
    style={{ background: look.bg, color: look.fg }}
    role="img"
    aria-label={`Capa ilustrativa: ${title}`}
  >
    <div className="absolute inset-0" style={{ background: look.block, clipPath: look.clip }} />
    <div className="absolute inset-y-0 left-0 w-[6px] bg-gradient-to-r from-black/25 to-transparent" />
    <div className="relative flex h-full flex-col justify-between p-[9%]">
      <p className="f-serif text-[clamp(0.95rem,1.5vw,1.3rem)] font-medium leading-[1.12]">{title}</p>
      <p className="f-serif text-[0.8rem] italic">Quitanda</p>
    </div>
  </div>
);

export const BookCover = ({ title, index = 0, box = false, boxLabel, testId }) => {
  const look = looks[index % looks.length];
  return (
    <motion.figure
      data-testid={testId}
      className="group relative [perspective:1000px]"
      whileHover={{ y: -8 }}
      transition={{ type: "spring", stiffness: 200, damping: 20 }}
    >
      <div className="relative transition-transform duration-700 ease-out group-hover:[transform:rotateY(-10deg)]">
        {box && (
          <div className="absolute inset-0 translate-x-3 -translate-y-3" aria-hidden="true">
            <Face title={title} look={looks[(index + 3) % looks.length]} />
          </div>
        )}
        <div className="relative">
          <Face title={title} look={look} />
        </div>
      </div>
      <figcaption className="mt-4 text-sm leading-snug text-[#121518]">
        {box && <span className="mr-2 text-[11px] uppercase tracking-[0.2em] text-[#A3401A]">{boxLabel}</span>}
        {title}
      </figcaption>
    </motion.figure>
  );
};
